import * as sup from "superstruct";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";
import { userResourceStruct } from "@/modules/auth/api/resources/user/userResourceStruct";
import { groupItemResourceStruct } from "@/modules/groups/api/resources/groupsResourceStruct";

import { subtaskResourceStruct } from "../resources/subtask/subtaskResourceStruct";
import { getDashboardTasksListPath } from "../resources/tasks/tasksResourceConsts";
import { tasksResourceStruct } from "../resources/tasks/tasksResourceStructs";

export const getDashboardTasksQuery = (
  jsonApi: JsonApiClient,
  {
    companyId,
    maxAgeDays,
  }: {
    companyId: string;
    maxAgeDays?: number;
  }
) => {
  return jsonApi.getMany({
    path: getDashboardTasksListPath(companyId),
    queryParams: {
      filter: {
        maxAgeDays,
      },
    },
    responseStruct: getTasksResponseStruct,
  });
};

const getTasksResponseStruct = createResponseStruct({
  data: tasksResourceStruct,
  included: sup.array(
    sup.union([
      subtaskResourceStruct,
      userResourceStruct,
      groupItemResourceStruct,
    ])
  ),
});
